export function formatToTwoDecimals(input: number): string {
  return (Math.round((input + Number.EPSILON) * 100) / 100).toFixed(2);
}

export function centsToDollars(cents: number): number {
  const centsPerDollar = 100;
  return cents / centsPerDollar;
}

export function numberWithCommas(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
